/**
 * DateFormat：日付＆時刻変換フォーマット
 */
export enum BookingDateFormat {
  HHmmss = 'HH:mm:ss',
  HHmm2 = 'HH:mm',
  yyyyMMddHHmmssSSS = 'yyyyMMddHHmmssSSS',
  yyyyMMddTHHmmss = 'yyyyMMddTHHmmss',
  yyyyMMddTHHmmss00 = 'yyyyMMddTHHmmss00',
  yyyyMMddTHHmmss00Z = 'yyyyMMddTHHmmss00Z',
  yyyyMMddTHHmmssZ = 'yyyyMMddTHHmmssZ',
  yyyyMMddHHmm = 'yyyyMMddHHmm',
  yyyy_MM_dd = 'yyyy-MM-dd',
  yyyyMMdd = 'yyyyMMdd',
  yyyyMMdd2 = 'yyyy/MM/dd',
  MMdd = 'MMdd',
  MMdd2 = 'MM/dd',
  day_of_week = 'c',
  yyyy_MM_dd_HH_mm = 'yyyy_MM_dd_HH_mm',
  EE = 'EE',
}
